import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const application: ApiFunc<`${typeof API.APPLICATION_FORM}{id}`, 'get'> = data =>
  instance.get(`${API.APPLICATION_FORM}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const applicationCreate: ApiFunc<`${typeof API.APPLICATION_FORM}`, 'post'> = data =>
  instance.post(API.APPLICATION_FORM, data)

export const applicationDelete: ApiFunc<`${typeof API.APPLICATION_FORM}{id}`, 'delete'> = data =>
  instance.delete(`${API.APPLICATION_FORM}${'id' in data ? prop('id', data) : data?.name}`)

export const applicationList: ApiFunc<`${typeof API.APPLICATION}`, 'get'> = data =>
  instance.get(API.APPLICATION, {
    params: data,
  })

export const applicationAnalytics: ApiFunc<`${typeof API.APPLICATION_ANALYTICS}`, 'get'> = data =>
  instance.get(API.APPLICATION_ANALYTICS, {
    params: data,
  })

export const applicationAll: ApiFunc<`${typeof API.APPLICATION_ALL}`, 'get'> = data =>
  instance.get(API.APPLICATION_ALL, {
    params: data,
  })

export const applicationTypes: ApiFunc<`${typeof API.APPLICATION_TYPES}`, 'get'> = data =>
  instance.get(API.APPLICATION_TYPES, {
    params: data,
  })

export const applicationChangeCourse: ApiFunc<`${typeof API.APPLICATION_CHANGE_COURSE}`, 'post'> = data =>
  instance.post(API.APPLICATION_CHANGE_COURSE, data)

export const applicationChangeCourseAdmin: ApiFunc<`${typeof API.APPLICATION_CHANGE_COURSE_ADMIN}`, 'post'> = data =>
  instance.post(API.APPLICATION_CHANGE_COURSE_ADMIN, data)

export const applicationStatus: ApiFunc<`${typeof API.APPLICATION_STATUS}`, 'put'> = data =>
  instance.put(API.APPLICATION_STATUS, data)

export const applicationFieldBatchCreate: ApiFunc<`${typeof API.APPLICATION_FIELD_BATCH}`, 'post'> = data =>
  instance.post(API.APPLICATION_FIELD_BATCH, data)

export const applicationFieldBatch: ApiFunc<`${typeof API.APPLICATION_FIELD_BATCH}{id}`, 'get'> = data =>
  instance.get(`${API.APPLICATION_FIELD_BATCH}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const applicationCategory: ApiFunc<`${typeof API.APPLICATION_CATEGORY}{id}`, 'get'> = data =>
  instance.get(`${API.APPLICATION_CATEGORY}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const applicationCategoryCreate: ApiFunc<`${typeof API.APPLICATION_CATEGORY}`, 'post'> = data =>
  instance.post(API.APPLICATION_CATEGORY, data)

export const applicationCategoryDelete: ApiFunc<`${typeof API.APPLICATION_CATEGORY}{id}`, 'delete'> = data =>
  instance.delete(`${API.APPLICATION_CATEGORY}${'id' in data ? prop('id', data) : data?.name}`)

export const applicationCategoryList: ApiFunc<`${typeof API.APPLICATION_CATEGORY}`, 'get'> = data =>
  instance.get(API.APPLICATION_CATEGORY, {
    params: data,
  })

export const applicationCategoryAll: ApiFunc<`${typeof API.APPLICATION_CATEGORY_ALL}`, 'get'> = data =>
  instance.get(API.APPLICATION_CATEGORY_ALL, {
    params: data,
  })

export const applicationRequest: ApiFunc<`${typeof API.APPLICATION_REQUEST}`, 'post'> = data =>
  instance.post(API.APPLICATION_REQUEST, data)

export const applicationRequestAll: ApiFunc<`${typeof API.APPLICATION_REQUEST_ALL}`, 'get'> = data =>
  instance.get(API.APPLICATION_REQUEST_ALL, {
    params: data,
  })

export const applicationRequestEdit: ApiFunc<`${typeof API.APPLICATION_REQUEST_EDIT}`, 'get'> = data =>
  instance.get(API.APPLICATION_REQUEST_EDIT, {
    params: data,
  })

export const applicationRequestUpdate: ApiFunc<`${typeof API.APPLICATION_REQUEST_UPDATE}`, 'put'> = data =>
  instance.put(API.APPLICATION_REQUEST_UPDATE, data)

export const applicationFields: ApiFunc<`${typeof API.APPLICATION_FIELDS}`, 'get'> = data =>
  instance.get(API.APPLICATION_FIELDS, {
    params: data,
  })

export const applicationGenerate: ApiFunc<`${typeof API.APPLICATION_GENERATE}`, 'post'> = data =>
  instance.post(API.APPLICATION_GENERATE, data)

export const applicationResetPassword: ApiFunc<`${typeof API.APPLICATION_RESET_PASSWORD}`, 'put'> = data =>
  instance.put(API.APPLICATION_RESET_PASSWORD, data)
